module.exports = __webpack_public_path__ + "img/icon-apple-green.bbaa66be.svg";